export const formatToCurrency = (amount: number, maximumFractionDigits = 2) => {
  const options = {
    style: 'currency',
    currency: 'MXN',
    maximumFractionDigits,
  } as const;

  return amount.toLocaleString('es-MX', options);
};
